<template>
  <div class="notice-detail">
    <div class="main" v-if="obj.id">
      <div class="head-container van-hairline--bottom">
        <div class="title">
          {{ obj.title }}
        </div>
        <div class="desc">
          {{ obj.createTime | formatDatetime('yyyy-MM-dd hh:mm') }}
        </div>
        <div class="desc" v-if="obj.receiverRange == 1">
          {{obj.campusList && obj.campusList.map(item=>item.name).join("、")}}
        </div>
        <div class="desc">老师：{{ obj.senderName }}</div>
        <div class="desc">学员：{{obj.receiverName}}</div>
      </div>
      <div class="content">
        <vx-mult-input-show :list="obj.content.list"></vx-mult-input-show>
      </div>
    </div>
    
    <page-footer-btn multipleBtns v-if="obj.id && obj.isNeedConfirm">
      <van-button square round block type="primary" @click="confirm" :disabled="obj.confirmStatus == 2">{{obj.confirmStatus == 2 ? '已确认收到':'确认收到'}}</van-button>
    </page-footer-btn>
    <empty-page :show="isDeleted" tips="已被机构删除"> </empty-page>
  </div>
</template>

<script>
import emptyPage from '@teacher/components/empty-page.vue';
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';
export default {
  name: 'notice-detail',
  data() {
    return {
      pageTitle: '通知详情',
      isDeleted: false,
      obj: {},
    };
  },
  computed: {},
  components: {
    emptyPage,
    pageFooterBtn
  },
  created() {
    let { id } = this.$route.params;
    this.$api.noticeInfo(id).then(res => {
      if (res.code == 200) {
        this.obj = res.data;
        app.vue.$emit('refresh-notice-list');
        if (!res.data.isNeedConfirm){
          app.vue.$emit('refresh-notice-num');
        }
      } else if (res.code == 830000404) {
        this.isDeleted = true;
      }
    });
  },
  methods: {    
    async confirm(){
      if (this.obj.confirmStatus == 2){
        return;
      }
      await this.$api.noticeConfirm({
        noticeId: this.obj.id
      });
      this.obj.confirmStatus = 2;
      app.vue.$emit('refresh-notice-num');
      app.vue.$emit('refresh-notice-list');
    }
  },
};
</script>

<style lang="scss" scoped>
.notice-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex:1 1 auto;
    background: var(--white);
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    overflow-y: auto;
    .head-container {
      margin-bottom:calc(var(--gap) * 12);
      padding-bottom: calc(var(--gap) * 4);
      .title {
        font-size: var(--fs-ex2);
        line-height: var(--lh-ex2);
        color: var(--g8);
        margin-bottom: calc(var(--gap) * 8);
      }
      .desc {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        margin-bottom: calc(var(--gap) * 8);
      }
    }
    .content {
    }
  }
}
</style>

